import { render, staticRenderFns } from "./SubmitForm10.vue?vue&type=template&id=7a57c38e&scoped=true"
import script from "./SubmitForm10.vue?vue&type=script&lang=ts"
export * from "./SubmitForm10.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a57c38e",
  null
  
)

export default component.exports